var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComfybeds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a00303;}.cls-2{fill:#dd2853;}.cls-3{fill:#e291a8;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 21",
    id: "Layer_21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,13a1,1,0,0,0-1,1v5H4V10a1,1,0,0,0-2,0V29a1,1,0,0,0,2,0V21H28v8a1,1,0,0,0,2,0V14A1,1,0,0,0,29,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.5,15H5.5a2.5,2.5,0,0,0,0,5h21a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 5,
    rx: 2,
    ry: 2,
    width: 9,
    x: 3,
    y: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 20,
    cy: 7,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,6H21V5a1,1,0,0,0-2,0V6H18a1,1,0,0,0,0,2h1V9a1,1,0,0,0,2,0V8h1a1,1,0,0,0,0-2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComfybeds);
export default __webpack_public_path__ + "static/media/comfybeds.1bb715b62415b06476c9b1a8f7752437.svg";
export { ForwardRef as ReactComponent };